module.exports = __webpack_public_path__ + "img/content5_960_15.a470f7ae.png";